import { FC } from 'react';

import FeatureFlagged from 'components/featureflag/FeatureFlagged';
import PageHeader from 'components/PageHeader';
import PaddedLayout from 'layout/MainLayout/PaddedLayout';
import { useIsSageHrEnabledQuery } from 'store/api/sage-hr-integration';
import { useIsWordPressEnabledQuery } from 'store/api/wordpress-integration';
import { FeatureFlag } from 'types/features';
import MatterSync from './components/MattersTiqTimeSync';
import SageHrSync from './components/SageHrSync';
import WordPressSync from './components/WordPressSync';

const DataIntegrationPage: FC = () => {
    const { data: isSageHrEnabled } = useIsSageHrEnabledQuery();
    const { data: isWordPressEnabled } = useIsWordPressEnabledQuery();

    return (
        <PaddedLayout className="overflow-hidden">
            <div className="flex h-full flex-col gap-4">
                <PageHeader titleId="data-integration.title" />
                <div className="new:gap-(--card-gap) flex flex-col gap-4 empty:hidden">
                    <FeatureFlagged flag={FeatureFlag.INTEGRATION_TIQ} action="show">
                        <MatterSync />
                    </FeatureFlagged>
                    {isSageHrEnabled && <SageHrSync />}
                    {isWordPressEnabled && <WordPressSync />}
                </div>
            </div>
        </PaddedLayout>
    );
};

export default DataIntegrationPage;
